<template>
  <AuthLayout
    eyebrow="Passwort"
    title="Neues Passwort festlegen"
    intro="Vergeben Sie ein neues Passwort, damit Ihr Zugang wieder sicher und einsatzbereit ist."
    card-title="Passwort aktualisieren"
    card-intro="Nutzen Sie ein starkes Passwort mit mindestens zwölf Zeichen, einer Zahl und einem Sonderzeichen."
    :aside-list="[
      'Mindestens zwölf Zeichen verwenden',
      'Zahl und Sonderzeichen ergänzen',
      'Danach direkt wieder anmelden'
    ]"
  >
    <Form @submit="submit" v-slot="{ errors }" :validation-schema="schema">

      <div class="form-floating mb-3">

        <Field type="password" as="input" id="password" name="password" class="form-control"
               :class="{'is-invalid': errors.password}" autocomplete="off" aria-required="true"
        />
        <label for="password">Neues Passwort</label>
        <ErrorMessage name="password" />
      </div>

      <div class="form-floating mb-3">

        <Field type="password" as="input" id="password_confirmation" name="password_confirmation" class="form-control"
               :class="{'is-invalid': errors.password_confirmation}" autocomplete="off" aria-required="true"
        />
        <label for="password">Passwort bestätigen</label>
        <ErrorMessage name="password_confirmation" />
      </div>

      <div v-if="showSuccess" class="alert alert-success mt-3">
        Das Passwort wurde geändert. Leite zum Login weiter...
      </div>
      <div v-if="showError" class="alert alert-danger mt-3">
        Das Passwort konnte nicht aktualisiert werden. {{errorMessage}}
      </div>
      <button type="submit" class="btn btn-primary mt-3 btn-block">Passwort speichern</button>
    </Form>
  </AuthLayout>
</template>

<script>
import AuthLayout from "@/components/layout/AuthLayout.vue";
import Yup from "@/yup";
import {useUserStore} from "@/stores/user";
import { Form, Field, ErrorMessage } from "vee-validate";
export default {
  name: "PasswordChange",
  components: {
    AuthLayout,
    Form,
    Field,
    ErrorMessage
  },
  data() {
    return {
      showSuccess: false,
      showError: false,
      errorMessage: '',
      schema: Yup.object({
        password: Yup.string()
            .required()
            .min(12, "Das Passwort muss mindestens 12 Zeichen lang sein.")
            .matches(
                /^(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>]).{12,}$/,
                "Das Passwort muss mindestens ein Sonderzeichen und eine Zahl enthalten."
            ),

        password_confirmation: Yup.string()
            .required("Password Bestätigung wird benötigt.")
            .oneOf([Yup.ref("password")], "Die Passwörter müssen übereinstimmen"),
      }),
    }
  },
  setup() {
    return {
      userStore: useUserStore(),
    }
  },
  methods: {
    submit(values) {
      this.userStore.apiAuthChangePassword(values.password, values.password_confirmation, this.$route.query.token).then(( ) => {
        //redirect
        this.showSuccess = true
        setTimeout(() => {
          this.$router.push({name: 'login'})
        }, 2000)
      }).catch(error => {
        this.showError = true
        this.errorMessage = error.response.data.message
      });
    }
  },
  created() {
  }
}
</script>
